import React, { Fragment } from 'react';
import classnames from 'classnames';

import Easing from './Easing/Easing';

import styles from './MotionUsage.css';
import easings from 'styles/_easings.css';

const Usage = () => (
  <Fragment>
    <section>
      <article className="flex-row">
        <div className="left">
          <h1 className="h1 page-title">
            Motion adds character to the product, providing visual feedback, hinting actions and establishing cohesive interactions.
          </h1>
        </div>

        <div className="right copy-content">
          <p>Motion creates an active two-way conversation with the user, and when used properly helps them as they interact with the interface, with all of its elements acting and reacting to one another in sync.</p>
          <p>When creating digital products with a human-centered design approach, the user interface needs to be intuitive, responsive and feel natural, and motion plays a fundamental role in it.</p>
          <p>Taking that into account, for this project there were created general motion specifications to serve as a baseline to a unified motion language across the entire product:</p>
        </div>
      </article>
    </section>

    <section className="bg-grey flex-grow-1 with-padding last">
      <article className="flex-row flex-justify-end flex-wrap">
        <div className="right copy-content">
          <h2 className="h2 page-subtitle">Easing</h2>
          <p>In order to have a natural interaction with the product, we must use animations that feel natural. With linear animations, everything feels mechanic and fake, but the user is used to natural interactions in the real world so the use of ease curves are very important, as they tend to mimic real-life interactions.</p>
        </div>

        <div className={classnames('flex-basis-100', styles.detailsMargin)}>
          <div className="flex flex-column flex-justify-between">
            <div className="flex flex-align-center">
              <div className={classnames('left', styles.withPaddingRight)}>
                <Easing func={easings['linear']} />
              </div>
              <div className="right flex">
                <p className={styles.withMinWidth}>Linear:</p>
                <span className="p">
                  <strong>cubic-bezier(0, 0, 1, 1)</strong>
                </span>
              </div>
            </div>
            <div className="flex flex-align-center">
              <div className={classnames('left', styles.withPaddingRight)}>
                <Easing func={easings['standard']} />
              </div>
              <div className="right flex">
                <p className={styles.withMinWidth}>Standard:</p>
                <span className="p">
                  <strong>cubic-bezier(0.4, 0, 0.2, 1)</strong>
                </span>
              </div>
            </div>
            <div className="flex flex-align-center">
              <div className={classnames('left', styles.withPaddingRight)}>
                <Easing func={easings['acelerate']} />
              </div>
              <div className="right flex">
                <p className={styles.withMinWidth}>Acelerate:</p>
                <span className="p">
                  <strong>cubic-bezier(0.8, 0, 0.9, 1)</strong>
                </span>
              </div>
            </div>
            <div className="flex flex-align-center">
              <div className={classnames('left', styles.withPaddingRight)}>
                <Easing func={easings['decelerate']} />
              </div>
              <div className="right flex">
                <p className={styles.withMinWidth}>Decelerate:</p>
                <span className="p">
                  <strong>cubic-bezier(0.1, 0, 0.2, 1)</strong>
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="right">
          <div className="copy-content">
            <h2 className="h2 page-subtitle">Duration of Animation</h2>
            <p>The duration may vary depending on the properties animated. A button being clicked needs to provide faster feedback than a notification entering the screen. Although the different duration, the end result will provide a cohesive motion language across all the product.</p>
          </div>

          <div className="flex flex-column flex-justify-between">
            <div className={classnames(styles.rowMarginBottom, 'flex')}>
              <p className={styles.withMinWidth}>150ms:</p>
              <span className="p">
                <strong>opacity / color changes (e.g. hover states)</strong>
              </span>
            </div>
            <div className={classnames(styles.rowMarginBottom, 'flex')}>
              <p className={styles.withMinWidth}>300ms:</p>
              <span className="p">
                <strong>position changes within elements (e.g. pagination)</strong>
              </span>
            </div>
            <div className={classnames(styles.rowMarginBottom, 'flex')}>
              <p className={styles.withMinWidth}>400ms:</p>
              <span className="p">
                <strong>object entering / exiting the screen (e.g. notifications)</strong>
              </span>
            </div>
            <div className={classnames(styles.rowMarginBottom, 'flex')}>
              <p className={styles.withMinWidth}>+500ms:</p>
              <span className="p">
                <strong>transitions between screens / complex animations</strong>
              </span>
            </div>
          </div>
        </div>

      </article>
    </section>
  </Fragment>
);


export default Usage;



// WEBPACK FOOTER //
// ./src/containers/foundations/Motion/MotionUsage.js